<template>
  <div>
    <div style="display: flex;justify-content: flex-end;">
      <b-button
        v-if="mostrarBotaoChecklist && !desabilitarEnvio"
        size="sm"
        variant="primary"
        style="background-color: #007bff !important; border-color: #007bff !important;"
        class="mr-1"
        :disabled="proposta.statusProposta === 'rejeitado'"
        @click="salvarPropostaChecklist(false, true)"
      >
        Enviar Checklist
      </b-button>

      <b-button
        v-if="mostrarBotaoChecklist"
        size="sm"
        variant="primary"
        class="mr-1"
        :disabled="proposta.statusProposta === 'rejeitado' || (proposta.itemChecklistPropostas && proposta.itemChecklistPropostas.length === 0) || desabilitarGeracao"
        @click="salvarPropostaChecklist(true, false)"
      >
        Gerar proposta
      </b-button>
      <b-button
        v-if="mostrarBotaoChecklist"
        size="sm"
        variant="primary"
        class="mr-1"
        :disabled="proposta.statusProposta === 'rejeitado' || (proposta.itemChecklistPropostas && proposta.itemChecklistPropostas.length === 0) || desabilitarGeracao"
        @click="salvarPropostaChecklist(false, false)"
      >
        Salvar checklist
      </b-button>

      <b-button
        v-if="mostrarBotaoSalvamento"
        size="sm"
        variant="primary"
        style="background-color: #007bff !important; border-color: #007bff !important;"
        :class="['mr-1', {'desabilitar-inputs': desabilitarInputs()}]"
        @click="enviarPropostaComercial"
      >
        Enviar Proposta
      </b-button>
      <b-button
        v-if="mostrarBotaoSalvamento"
        size="sm"
        variant="primary"
        :class="['mr-1', {'desabilitar-inputs': desabilitarInputs()}]"
        @click="salvarProposta(false)"
      >
        Salvar e Fechar
      </b-button>
      <b-button
        v-if="mostrarBotaoSalvamento"
        size="sm"
        variant="primary"
        :class="['mr-1',{'desabilitar-inputs': desabilitarInputs()}]"
        @click="salvarProposta(true)"
      >
        Salvar e Continuar Editando
      </b-button>
      <b-button
        size="sm"
        variant="danger"
        class="mr-1"
        @click="closeModal"
      >
        Cancelar
      </b-button>
    </div>
    <b-tabs>
      <b-tab
        no-body
      >
        <template slot="title">
          <span>Trâmites com a Pessoa</span>
          <font-awesome-icon
            style="color: rgba(0, 121, 191);"
            class="ml-50"
            :icon="faComment"
          />
        </template>
        <div class="pb-2 w-75">
          <b-textarea
            v-model="comentarioTramite"
            placeholder="Escreva um comentário..."
            max-rows="3"
            :no-resize="true"
          />
          <div class="h-50">
            <b-btn
              class="btn-sm btn-secondary save"
              :disabled="proposta.id > 0 && (proposta.statusProposta !== 'pendenteenvio' && proposta.statusProposta !== 'naoaprovada')"
              @click="saveObservacaoInternaTramite(false)"
            >
              Salvar
            </b-btn>
          </div>
        </div>
        <tramite-observacao
          v-for="(tramite, index) in tramites"
          :key="index"
          :value="tramite"
          :proposta-atual="proposta"
          @update-comentario="updateTramiteObservacao($event)"
          @delete-comentario="deleteTramiteObservacao($event)"
        />
      </b-tab>
      <b-tab
        no-body
      >
        <template slot="title">
          <span>Observações internas</span>
          <font-awesome-icon
            style="color: rgba(251, 140, 0);"
            class="ml-50"
            :icon="faBell"
          />
        </template>
        <div class="pb-2 w-75">
          <b-textarea
            v-model="comentarioObservacao"
            placeholder="Escrever uma observação interna..."
            max-rows="3"
            :no-resize="true"
          />
          <div class="h-50">
            <b-btn
              class="btn-sm btn-secondary save"
              @click="saveObservacaoInternaTramite(true)"
            >
              Salvar
            </b-btn>
          </div>
        </div>
        <tramite-observacao
          v-for="(comentario, index) in observacoesInternas"
          :key="index"
          :value="comentario"
          @update-comentario="updateTramiteObservacao($event)"
          @delete-comentario="deleteTramiteObservacao($event)"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<style lang="scss">
//Observaçao - tramite
.save {
  float: right;
  margin-right: 1rem;
  margin-top: 0.5rem;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faComment, faBell,
} from '@fortawesome/free-regular-svg-icons'
import { getUserData, getUserInfo } from '@/auth/utils'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'FooterCadastro',
  components: {
    FontAwesomeIcon,
    TramiteObservacao: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/tramite-observacao/TramiteObservacao.vue'),
  },
  props: {
    tramites: {
      type: Array,
      default: () => [],
    },
    observacoesInternas: {
      type: Array,
      default: () => [],
    },
    propostaIdAtual: {
      type: Number,
      default: 0,
    },
    proposta: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      faComment,
      faBell,
      comentarioObservacao: null,
      comentarioTramite: null,
      desabilitarEnvio: true,
      desabilitarGeracao: true,
      permissaoAlterarPropostaAprovada: getUserData().permissaoAlterarPropostaAprovada,
    }
  },
  computed: {
    ...mapGetters('proposta', ['getCnpjInput']),
    mostrarBotaoSalvamento() {
      return this.proposta.tipoProposta === 'semchecklist'
      || ((this.proposta.tipoProposta === 'constituicao' || this.proposta.tipoProposta === 'transferencia') && this.proposta.geradoProposta)
    },
    mostrarBotaoChecklist() {
      return (this.proposta.tipoProposta === 'constituicao' || this.proposta.tipoProposta === 'transferencia') && !this.proposta.geradoProposta
    },
  },
  methods: {
    ...mapActions('listas', ['adicionadoTramite', 'adicionadoObservacao', 'setCnpjInput']),
    closeModal() {
      this.$emit('close-modal')
    },
    salvarProposta(continuarEditando) {
      this.$emit('salvar-proposta', continuarEditando)
    },
    // NOVO MÉTODO PARA O BOTÃO DE ENVIAR PROPOSTA
    enviarPropostaComercial() {
      // Emite o evento para o pai (cadastroproposta.vue) executar a lógica de envio
      this.$emit('enviar-proposta')
    },
    salvarPropostaChecklist(gerarProposta, enviarProposta) {
      if (this.proposta.checklistCNPJ[0] && this.getCnpjInput && this.getCnpjInput !== '' && !this.proposta.checklistCNPJ[0].listaRespostas.some(f => f.includes(this.getCnpjInput))) {
        api.buscarRazaoSocialCnpj(this.getCnpjInput, false)
          .then(payload => {
            this.proposta.checklistCNPJ[0].listaRespostas.push(payload.data)
            this.setCnpjInput(null)
            this.$emit('salvar-checklist', { gerarProposta, enviarProposta })
          })
      } else {
        this.$emit('salvar-checklist', { gerarProposta, enviarProposta })
      }
    },
    saveObservacaoInternaTramite(isInterna) {
      if (this.propostaIdAtual && this.propostaIdAtual > 0) {
        api.addComentarioProposta(this.propostaIdAtual, isInterna ? this.comentarioObservacao : this.comentarioTramite, isInterna)
          .then(payload => {
            const observacao = payload.data
            if (isInterna) {
              if (!this.proposta.observacoesInternas) {
                this.proposta.observacoesInternas = []
              }
              this.proposta.observacoesInternas.unshift(observacao)
              this.adicionadoObservacao({ id: this.propostaIdAtual, existe: true })
            } else {
              if (!this.proposta.tramites) {
                this.proposta.tramites = []
              }
              this.proposta.tramites.unshift(observacao)
              this.adicionadoTramite({ id: this.propostaIdAtual, existe: true })
            }
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response.statusText !== '' ? err.response.statusText : (err.response.data.message || err.message),
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            })
            throw err
          })
      } else {
        const observacao = {
          id: 0,
          comentario: isInterna ? this.comentarioObservacao : this.comentarioTramite,
          observacaoInterna: isInterna,
          usuarioNome: getUserInfo().nome,
          dataCadastroTramiteObservacao: Date.now(),
        }
        if (isInterna) {
          if (!this.proposta.observacoesInternas) {
            this.proposta.observacoesInternas = []
          }
          this.proposta.observacoesInternas.push(observacao)
        } else {
          if (this.proposta.tramites) {
            this.proposta.tramites = []
          }
          this.proposta.tramites.push(observacao)
        }
      }
      this.comentarioObservacao = null
      this.comentarioTramite = null
    },
    updateTramiteObservacao(tramiteObservacao) {
      api.updateComentarioProposta(this.propostaIdAtual, tramiteObservacao.observacao)
        .then(payload => {
          const comentario = payload.data
          let comentarioAntigo = this.proposta.tramites.findIndex(find => find.id === comentario.id)
          if (comentarioAntigo >= 0) {
            this.proposta.tramites.splice(comentarioAntigo, 1)
            this.proposta.tramites.splice(comentarioAntigo, 0, comentario)
          } else {
            comentarioAntigo = this.proposta.observacoesInternas.findIndex(find => find.id === comentario.id)
            this.proposta.observacoesInternas.splice(comentarioAntigo, 1)
            this.proposta.observacoesInternas.splice(comentario, 0, comentario)
          }
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: err.response.statusText !== '' ? err.response.statusText : (err.response.data.message || err.message),
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
          throw err
        })
    },
    deleteTramiteObservacao(tramiteObservacao) {
      if (tramiteObservacao.id && tramiteObservacao.id > 0) {
        api.deleteComentarioProposta(tramiteObservacao.id)
      }
      if (!tramiteObservacao.observacao.observacaoInterna) {
        const comentarioAntigo = this.proposta.tramites.findIndex(find => find.id === tramiteObservacao.id)
        this.proposta.tramites.splice(comentarioAntigo, 1)
        this.adicionadoTramite({ id: this.propostaIdAtual, existe: this.proposta.tramites.length > 0 })
      } else {
        const observacaoAntiga = this.proposta.observacoesInternas.findIndex(find => find.id === tramiteObservacao.id)
        this.proposta.observacoesInternas.splice(observacaoAntiga, 1)
        this.adicionadoObservacao({ id: this.propostaIdAtual, existe: this.proposta.observacoesInternas.length > 0 })
      }
    },
    habilitarBotao(value) {
      if (value === 'gerenteresponsavel' || this.proposta.retornou) {
        this.desabilitarGeracao = false
        this.desabilitarEnvio = true
      } else {
        this.desabilitarEnvio = false
        this.desabilitarGeracao = true
      }
    },
    desabilitarInputs() {
      return this.proposta.id && ((this.proposta.statusProposta === 'aguardandoassinatura' && this.permissaoAlterarPropostaAprovada === false) || (this.proposta.statusProposta === 'finalizada' && this.permissaoAlterarPropostaAprovada === false) || (this.proposta.statusProposta === 'aprovada' && this.permissaoAlterarPropostaAprovada === false))
    },
  },
}
</script>
